import { Component, TransferState, ViewChild, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ScannerQRCodeConfig,
  ScannerQRCodeResult,
  LOAD_WASM,
  NgxScannerQrcodeComponent,
} from 'ngx-scanner-qrcode';
import { ToastrService } from 'ngx-toastr';
import { makeStateKey } from '@angular/platform-browser';

import { UserWallet, WalletTransactionItem, WalletType } from '@/app/shared/interface/user.interface';
import { AuthService, USER_POINT_WALLET, USER_WALLET, USERNAME } from '@/app/shared/services/auth.service';
import { WalletService } from '@/app/shared/services/wallet.service';
import { Router } from '@angular/router';
import {QueryStringService} from "@/app/shared/services/querystring.service";
import { isPlatformBrowser } from '@angular/common';
import { BaseResponse } from '@/app/shared/interface/common.interface';
import { useSafeTimeout } from '@/app/shared/ssr-util';

const USER_WALLET_TYPE0 = makeStateKey<UserWallet>('USER_WALLET_TYPE0');
const USER_WALLET_TYPE2 = makeStateKey<UserWallet>('USER_WALLET_TYPE2');

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrl: './wallet.component.scss'
})
export class WalletComponent implements OnInit {

  @ViewChild('scanModal', { static: false }) scanModal: any;
  @ViewChild('action') action!: NgxScannerQrcodeComponent;
  @ViewChild('welcomeBackRewardModal', { static: false }) welcomeBackRewardModal: any;

  userWalletType0: UserWallet | null = null;
  userWalletType2: UserWallet | null = null;
  walletHistory0: WalletTransactionItem[] = [];
  walletHistory2: WalletTransactionItem[] = [];

  voucherCode: string = '';

  headerColumns = [
    'Mã giao dịch',
    'Mô tả',
    'Cộng xu',
    'Trừ xu',
    'Thời gian',
    'Số lượng còn lại'
  ];

  hasCameraPermission: boolean = false;
  public config: any = {
    constraints: {
      video: {
        width: 0,
      },
    },
  };

  body: any = {
    limit: 15,
    offset: 0
  }

  pagination0: any = {
    currentPage: 1,
    pageSize: this.body.limit
  };

  pagination2: any = {
    currentPage: 1,
    pageSize: this.body.limit,
  };
  
  reward: any;

  private safeTimeout = useSafeTimeout();

  constructor(
    private walletService: WalletService,
    private modalService: NgbModal,
    private toastService: ToastrService,
    private transferState: TransferState,
    private router: Router,
    private queryStringService: QueryStringService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.getUserWallet(WalletType.Coin);
    this.getUserWallet(WalletType.TempCoin);
    // LOAD_WASM().subscribe();
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.config.constraints.video.width = window.innerWidth;

      if (window.history.state && window.history.state.fromWelcomeBack) {
        this.authService.getCampaignReward({ campaignName: 'DvWelcomeLetterCampaign' }).subscribe({
          next: (res: BaseResponse) => {
            if (res && res.data) {
              this.reward = res.data;
              this.safeTimeout(() => {
                this.welcomeBackRewardModal.openModal();
              }, 100); 
            }
          }
        });
      }
    }
  }

  getUserWallet(walletType: WalletType) {
    let body = {
      userName: this.transferState.get(USERNAME, ''),
      walletType: walletType
    }
    this.walletService.getUserWallet(body).subscribe({
      next: (res: any) => {
        if (res) {
          if (walletType === WalletType.Coin) {
            this.userWalletType0 = res;
          }
          else {
            this.userWalletType2 = res;
          }

          this.getWalletHistory(res.id, res.walletType);
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  getWalletHistory(walletId: string, type?: number) {
    const pagination = type === 0 ? this.pagination0 : this.pagination2;
    const offset = (pagination.currentPage - 1) * pagination.pageSize;

    this.walletService.getUserWalletTransaction({
      walletId: walletId,
      limit: pagination.pageSize,
      offset: offset
    }).subscribe({
      next: (res) => {
        if (type == 0) {
          this.walletHistory0 = res?.items ?? [];
          this.pagination0.totalItems = res?.totalCount ?? 0;
        } else {
          this.walletHistory2 = res?.items ?? [];
          this.pagination2.totalItems = res?.totalCount ?? 0;
        }
      },
      error: () => {
        this.toastService.error('Không thể lấy lịch sử giao dịch', '', { positionClass: 'toast-top-right' });
      }
    });
  }

  async scanQRCode() {
    this.requestCameraPermission();
  }

  async requestCameraPermission() {
    const permissionObj = await navigator.permissions.query({ name: 'camera' as PermissionName });
    this.openModal();

    if (permissionObj.state === 'granted') {
      await this.checkCamera();
    } else {
      this.hasCameraPermission = false;
    }
  }

  async checkCamera() {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true }).catch(() => {
      this.toastService.warning('Thiết bị của bạn chưa kết nối với camera', '', { positionClass: 'toast-top-right' });
      return;
    });

    if (stream) {
      this.hasCameraPermission = true;
      stream.getTracks().forEach((track) => track.stop());
    }

    if (this.hasCameraPermission) {
      document.getElementById('btnStart')?.click();
    }
  }

  async openModal() {
    this.modalService
      .open(this.scanModal, {
        ariaLabelledBy: 'register-add-Modal',
        centered: true,
        backdrop: 'static',
        windowClass: 'theme-modal modal-login modal-dialog-scrollable',
      })
      .result.then(
        () => this.closeModal(),
        () => this.closeModal()
      );
  }

  public onEvent(e: ScannerQRCodeResult[], action?: any): void {
    this.voucherCode = e[0].value;
    this.handle(action, 'pause');
    this.submit();
  }

  public async handle(action: any, fn: string): Promise<void> {
    const playDeviceFacingBack = (devices: any[]) => {
      const device = devices.find((f) => /back|rear|environment/gi.test(f.label));
      action.playDevice(device ? device.deviceId : devices[0].deviceId);
    };

    if (fn === 'start') {
      action[fn](playDeviceFacingBack).subscribe((r: any) => console.log(fn, r), alert);
    } else {
      action[fn]().subscribe((r: any) => console.log(fn, r), alert);
    }
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  submit() {
    if (this.voucherCode.trim() === '') {
      this.toastService.warning('Vui lòng nhập mã voucher', '', { positionClass: 'toast-top-right' });
      return;
    }

    this.walletService.claimVoucher({ voucherCode: this.voucherCode }).subscribe({
      next: (res: UserWallet) => {
        this.toastService.success('Nhận voucher thành công', '', { positionClass: 'toast-top-right' });
        this.voucherCode = '';

        if (res.walletType === 0) {
          this.userWalletType0 = res;
        } else if (res.walletType === 2) {
          this.userWalletType2 = res;
        }

        this.closeModal();
      },
      error: (err: any) => {
        this.toastService.error(err?.error?.message || 'Có lỗi xảy ra, vui lòng thử lại sau', '', { positionClass: 'toast-top-right' });
      }
    });
  }

  gotoGiftList() {
    this.router.navigate(['/gift-list']);
  }

  setPaginate(event: any, type: number) {
    if (type == 0) {
      this.pagination0.currentPage = event;
      this.getWalletHistory(this.userWalletType0?.id || '', type);
    }
    else {
      this.pagination2.currentPage = event;
      this.getWalletHistory(this.userWalletType2?.id || '', type);
    }
  }
}
